/* Aniversário Bulls - contagem regressiva, chuva de confete ao abrir e explosão ao adicionar no carrinho */
(function () {
  var TZ = 'America/Cuiaba';
  var CORES = ['#f83a3a', '#ffc83d', '#2d7bff', '#22c55e', '#ff4fa3', '#ff9800', '#9c4dff', '#00c2d1'];
  var FORMAS = ['retangulo', 'circulo', 'fita', 'triangulo', 'estrela', 'quadrado'];
  var CLIP = {
    triangulo: 'polygon(50% 0,100% 100%,0 100%)',
    estrela: 'polygon(50% 0,62% 36%,100% 38%,70% 60%,80% 100%,50% 76%,20% 100%,30% 60%,0 38%,38% 36%)'
  };

  function reduzido() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // uma peça de confete com cor e formato de festa
  function peca(i, leve) {
    var p = document.createElement('i');
    // modo leve (chuva): só formas simples, sem clip-path, que custam menos pra pintar
    var f = leve ? ['retangulo', 'circulo', 'fita', 'quadrado'][i % 4] : FORMAS[i % FORMAS.length];
    p.style.background = CORES[(i * 3 + Math.floor(i / 8)) % CORES.length];
    if (f === 'retangulo') { p.style.width = '9px'; p.style.height = '15px'; }
    else if (f === 'circulo') { p.style.width = p.style.height = '10px'; p.style.borderRadius = '50%'; }
    else if (f === 'fita') { p.style.width = '4px'; p.style.height = (22 + Math.random() * 14) + 'px'; p.style.borderRadius = '4px'; }
    else if (f === 'quadrado') { p.style.width = p.style.height = '9px'; p.style.borderRadius = '2px'; }
    else { p.style.width = p.style.height = '13px'; p.style.clipPath = CLIP[f]; }
    return p;
  }

  function segundosAteMeiaNoite() {
    var p = new Intl.DateTimeFormat('en-GB', { timeZone: TZ, hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
    var v = {};
    p.forEach(function (x) { v[x.type] = parseInt(x.value, 10); });
    return 86400 - (v.hour * 3600 + v.minute * 60 + v.second);
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  var recarregou = false;
  function atualizarContagem() {
    var els = document.querySelectorAll('[data-aniv-countdown]');
    var hs = document.querySelectorAll('[data-aniv-h]');
    if (!els.length && !hs.length) return;
    var s = segundosAteMeiaNoite();
    var hh = pad(Math.floor(s / 3600)), mm = pad(Math.floor((s % 3600) / 60)), ss = pad(s % 60);
    els.forEach(function (el) { el.textContent = hh + ':' + mm + ':' + ss; });
    hs.forEach(function (el) { el.textContent = hh; });
    document.querySelectorAll('[data-aniv-m]').forEach(function (el) { el.textContent = mm; });
    document.querySelectorAll('[data-aniv-s]').forEach(function (el) { el.textContent = ss; });
    if (s >= 86398 && !recarregou) { recarregou = true; setTimeout(function () { location.reload(); }, 2500); }
  }

  // explosão de confete (ao adicionar no carrinho)
  function confete(origemX, origemY) {
    if (reduzido()) return;
    var box = document.createElement('div');
    box.className = 'bulls-aniv-burst';
    var x0 = origemX != null ? origemX : window.innerWidth / 2;
    var y0 = origemY != null ? origemY : window.innerHeight * 0.4;
    for (var i = 0; i < 90; i++) {
      var p = peca(i);
      p.style.left = x0 + 'px';
      p.style.top = y0 + 'px';
      box.appendChild(p);
      var ang = Math.random() * Math.PI * 2;
      var forca = 140 + Math.random() * 300;
      var dx = Math.cos(ang) * forca;
      var dy = Math.sin(ang) * forca - 140;
      p.animate([
        { transform: 'translate(0,0) rotate(0deg) rotateX(0deg)', opacity: 1 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) rotate(' + (Math.random() * 360) + 'deg) rotateX(360deg)', opacity: 1, offset: 0.4 },
        { transform: 'translate(' + (dx * 1.2) + 'px,' + (dy + 460) + 'px) rotate(' + (Math.random() * 900) + 'deg) rotateX(900deg)', opacity: 0 }
      ], { duration: 1700 + Math.random() * 1100, easing: 'cubic-bezier(.2,.7,.3,1)', fill: 'forwards' });
    }
    document.body.appendChild(box);
    setTimeout(function () { box.remove(); }, 3200);
  }

  // chuva de confete ao abrir a home ou uma página de produto
  function chuva() {
    if (reduzido()) return;
    var box = document.createElement('div');
    box.className = 'bulls-aniv-burst';
    var largura = window.innerWidth, altura = window.innerHeight;
    // poucas peças e só transform: leve o bastante pra não travar a página
    var total = largura < 700 ? 26 : 44;
    var frag = document.createDocumentFragment();
    var fins = [];
    for (var i = 0; i < total; i++) {
      var p = peca(i, true);
      p.style.left = (Math.random() * largura) + 'px';
      p.style.top = '-30px';
      p.style.opacity = '0';
      frag.appendChild(p);
      fins.push(p);
    }
    box.appendChild(frag);
    document.body.appendChild(box);
    fins.forEach(function (p) {
      var bal = 30 + Math.random() * 40;
      var sinal = Math.random() < 0.5 ? -1 : 1;
      p.animate([
        { transform: 'translate3d(0,0,0) rotate(0deg)', opacity: 1 },
        { transform: 'translate3d(' + (sinal * bal) + 'px,' + (altura * 0.5) + 'px,0) rotate(280deg)', opacity: 1, offset: 0.5 },
        { transform: 'translate3d(' + (-sinal * bal * 0.6) + 'px,' + (altura + 40) + 'px,0) rotate(560deg)', opacity: 1, offset: 0.92 },
        { transform: 'translate3d(0,' + (altura + 60) + 'px,0) rotate(600deg)', opacity: 0 }
      ], { duration: 2800 + Math.random() * 1800, delay: Math.random() * 1200, easing: 'linear', fill: 'forwards' });
    });
    setTimeout(function () { box.remove(); }, 6500);
  }

  // só começa depois que a página terminou de carregar e o navegador está ocioso
  function quandoOcioso(fn) {
    var go = function () {
      if (window.requestIdleCallback) window.requestIdleCallback(fn, { timeout: 2000 });
      else setTimeout(fn, 1000);
    };
    if (document.readyState === 'complete') go();
    else window.addEventListener('load', function () { setTimeout(go, 300); }, { once: true });
  }

  var ultimo = 0;
  function disparar() {
    var agora = Date.now();
    if (agora - ultimo < 1500) return;
    ultimo = agora;
    confete();
  }

  // confete quando um item entra no carrinho (qualquer caminho: página, card, carrinho lateral)
  if (window.BULLS_ANIV && window.BULLS_ANIV.hoje) {
    var origFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0] && arguments[0].url ? arguments[0].url : String(arguments[0]);
      var p = origFetch.apply(this, arguments);
      if (/\/cart\/add/.test(url)) { p.then(function (r) { if (r && r.ok) disparar(); }).catch(function () {}); }
      return p;
    };
  }

  var tipo = (window.Shopify && window.Shopify.designMode) ? '' : (window.BULLS_ANIV && window.BULLS_ANIV.pagina) || '';
  if (window.BULLS_ANIV && window.BULLS_ANIV.hoje && (tipo === 'index' || tipo === 'product')) {
    quandoOcioso(chuva);
  }

  window.bullsAnivConfete = confete;
  window.bullsAnivChuva = chuva;
  atualizarContagem();
  setInterval(atualizarContagem, 1000);
})();
